module.exports = __webpack_public_path__ + "img/dashboard-banner.5840c749.png";